import {useEmailContext} from '../../../../../context';
import {THyperlinkLocalStates} from './types';
import {useEffect} from 'react';

interface IUseUpdateHyperlinkState {
    setHyperlinkStates: React.Dispatch<React.SetStateAction<THyperlinkLocalStates>>;
    hyperlinkStates: THyperlinkLocalStates;
}

export const useUpdateHyperlinkState = ({
    hyperlinkStates,
    setHyperlinkStates
}: IUseUpdateHyperlinkState) => {
    const {
        states: {hyperlinkState}
    } = useEmailContext();

    useEffect(() => {
        if (
            hyperlinkState?.text &&
            hyperlinkState?.text !== hyperlinkStates.text &&
            hyperlinkState?.active
        ) {
            setHyperlinkStates(prev => ({...prev, text: hyperlinkState.text}));
        }
    }, [hyperlinkState?.text]);
};
